import { t } from "i18next";
import Close from "../../images/close.svg";

function CloseButton(props) {
  return (
    <div className="">
      <button onClick={props.onClick.bind(this)}>
        <img src={Close} alt={t('alt_close_button')}></img>
      </button>
    </div>
  );
}

export default CloseButton;